import { type IShiftDetailsFormValues } from '~/components/ShiftRequestRedesign/ShiftDetails/ShiftDetailsForm/useShiftDetailsForm';
import { buildJobPayloads } from '../adapters/buildJobPayloads';
import { MultiDayShiftsClient } from '../clients';
import { type IPostShiftsResult } from '../types';

export async function postShifts(
  formValues: IShiftDetailsFormValues,
  officeId: string,
  duplicate?: boolean,
): Promise<IPostShiftsResult> {
  const jobPayloads = buildJobPayloads(formValues, duplicate ? { duplicate } : undefined);

  const response = await MultiDayShiftsClient.postMultiDayShifts(officeId, jobPayloads);

  const jobIds = (response.jobs ?? []).map((j) => j.id);
  const normalizedResponse = { ...response, jobs: jobIds };

  const professionalIds = formValues.invite;
  let hadInvites = false;

  if (professionalIds.length > 0 && jobIds.length > 0) {
    await MultiDayShiftsClient.inviteProfessionalsToJobs(jobIds, professionalIds, officeId);
    hadInvites = true;
  }

  return { response: normalizedResponse, hadInvites };
}
